import React, { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import FinancingCard from "./FinancingCard";
import "./FinancingCarousel.scss";

const FinancingCarousel = ({ financiaciones }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Función para agrupar las financiaciones en chunks
  const chunkArray = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };

  // Agrupar financiaciones según el dispositivo
  const itemsPerSlide = isMobile ? 1 : 3;
  const groupedFinanciaciones = chunkArray(financiaciones, itemsPerSlide);

  return (
    <div className="row d-flex justify-content-center mb-5">
      <div className="col-12">
        <div style={{ position: "relative", paddingBottom: "50px" }}>
          <Carousel
            indicators={true}
            controls={true}
            interval={null}
            style={{ margin: 0 }}
            className="financing-carousel"
          >
            {groupedFinanciaciones.map((group, groupIdx) => (
              <Carousel.Item key={groupIdx} style={{ padding: "10px 25px" }}>
                <div className="d-flex justify-content-center">
                  <div className="row w-100">
                    {group.map((f, idx) => (
                      <div key={f.id || idx} className={isMobile ? "col-12" : "col-lg-4 col-md-4"}>
                        <FinancingCard {...f} />
                      </div>
                    ))}
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default FinancingCarousel;

